import { Component } from '@angular/core';

@Component({
	selector: 'block-ui-template',
	templateUrl: './block-ui-template.html',
	standalone: false
})

export class BlockUITemplateComponent {
	public message: string;

	constructor() { }
}
